import Vue from 'vue'
import Vuex from 'vuex'
import userModule from './modules/user'

// 注册Vuex
Vue.use(Vuex)

// 创建并导出store实例
export default new Vuex.Store({
  modules: {
    user: userModule
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js